import { z } from 'zod';
import { WatchedAlertRuleSchema } from '../base.js';
export const DeleteWatchedRuleRequestQuerySchema = WatchedAlertRuleSchema.pick({ id: true });
export const DeleteWatchedRuleRequestSchema = DeleteWatchedRuleRequestQuerySchema;
export const DeleteWatchedRuleResponseSchema = z.void();
